<template>
  <v-card variant="flat" :height="cardHeight">
    <v-card-text class="pa-0">
      <v-textarea
        class="kpi_description mt-2"
        v-model="description"
        :label="$t('labels.description')"
        persistent-hint
        variant="outlined"
        density="compact"
        name="description"
        hide-details
        no-resize
      ></v-textarea>
    </v-card-text>
  </v-card>
</template>
<script>
import utils from "../mixins/utils";

export default {
  mixins: [utils],
  props: ["parentDescription", "containerHeight"],
  emits: ["updateDescription"],
  data() {
    return {
      description: this.parentDescription,
    };
  },

  watch: {
    description(value) {
      this.$emit("updateDescription", value);
    },
  },
  computed: {
    cardHeight() {
      return `calc(${parseFloat(this.containerHeight) / 4 + 16}px)`;
    },
    textareaMaxHeight() {
      return `calc(${parseFloat(this.containerHeight) / 4}px - 1px)`; // Adjust for padding/margin
    },
  },
};
</script>

<style scoped>
.kpi_description :deep(textarea) {
  overflow-y: auto;
  height: v-bind(textareaMaxHeight);
  max-height: v-bind(cardHeight);
}
</style>
